import { render, staticRenderFns } from "./FloatingButtonGroup.vue?vue&type=template&id=f5678abc&"
import script from "./FloatingButtonGroup.vue?vue&type=script&lang=js&"
export * from "./FloatingButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports